import { useState, useEffect } from "react";
import PropTypes, { object } from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { RequestService } from "services/RequestService";

function AddForm({ formData, handleChange, handleSubmit, validatePassword, passwordMatchError }) {
  const [companies, setCompanies] = useState([]);
  const [userTypes, setUserTypes] = useState({});
  const [passwordErrors, setPasswordErrors] = useState([]);

  useEffect(() => {
    const fetchUserTypes = async () => {
      try {
        const response = await RequestService.get("Auth/get-all-roles");
        if (response.data && !response.data.error) {
          setUserTypes(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching user types:", error);
      }
    };

    const fetchCompanies = async () => {
      try {
        const response = await RequestService.get("Companies");
        if (response.data && !response.data.error) {
          setCompanies(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    fetchUserTypes();
    fetchCompanies();
  }, []);

  const handlePasswordChange = (e) => {
    const { value } = e.target;
    const errors = validatePassword(value);
    setPasswordErrors(errors);
    handleChange(e);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MDInput
            fullWidth
            label="الاسم"
            name="displayName"
            value={formData.displayName}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            fullWidth
            label="البريد الإلكتروني"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            fullWidth
            type="password"
            label="كلمة المرور"
            name="password"
            value={formData.password}
            onChange={handlePasswordChange}
            required
          />
          {passwordErrors.length > 0 && (
            <MDBox mt={1}>
              {passwordErrors.map((error, index) => (
                <MDTypography key={index} variant="caption" color="error">
                  {error}
                </MDTypography>
              ))}
            </MDBox>
          )}
        </Grid>
        <Grid item xs={12}>
          <MDInput
            fullWidth
            type="password"
            label="تأكيد كلمة المرور"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
          {passwordMatchError && (
            <MDBox mt={1}>
              <MDTypography variant="caption" color="error">
                {passwordMatchError}
              </MDTypography>
            </MDBox>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel id="userType-label">نوع المستخدم</InputLabel>
            <Select
              labelId="userType-label"
              id="userType"
              name="userType"
              value={formData.userType}
              label="نوع المستخدم"
              onChange={handleChange}
              sx={{ 
                height: "45px",
                "& .MuiSelect-select": {
                  paddingTop: "10px",
                  paddingBottom: "10px"
                }
              }}
            >
              <MenuItem value="">
                <em>اختر نوع المستخدم</em>
              </MenuItem>
              {Object.keys(userTypes).map((key) => (
                    
                    <MenuItem key={key} value={userTypes[key]}>
                      {key 
                      
                   
                      }
                    </MenuItem>
                  ))} 
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel id="company-label">الشركة</InputLabel>
            <Select
              labelId="company-label"
              id="companyId"
              name="companyId"
              value={formData.companyId}
              label="الشركة"
              onChange={handleChange}
              sx={{ 
                height: "45px",
                "& .MuiSelect-select": {
                  paddingTop: "10px",
                  paddingBottom: "10px"
                }
              }}
            >
              <MenuItem value="">
                <em>اختر الشركة</em>
              </MenuItem>
              {companies.map((company) => (
                <MenuItem key={company.id} value={company.id}>
                  {company.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </form>
  );
}

AddForm.propTypes = {
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  validatePassword: PropTypes.func.isRequired,
  passwordMatchError: PropTypes.string,
};

export default AddForm;